// store/magicMoment.ts — P3 magic moment fired-state mirror.
//
// Per FSM (state_machines/magic_moment.yaml), localStorage is the primary
// persistence layer; BE is secondary (v0.5 cross-device merge). This store
// is a thin in-memory cache so React components subscribe and re-render
// when a moment fires within the same tab session.
import { create } from 'zustand';
import type { MagicMomentId } from '@/lib/magic_moments';

interface MagicMomentStore {
  fired: Record<MagicMomentId, string | null>;
  markFired: (id: MagicMomentId, ts?: string) => void;
  hydrate: (snapshot: Partial<Record<MagicMomentId, string | null>>) => void;
  reset: () => void;
}

const initial: Record<MagicMomentId, string | null> = {
  iron_kill_first_seen: null,
  first_council_lifetime: null,
  report_ready_first_complete: null,
};

export const useMagicMoment = create<MagicMomentStore>((set) => ({
  fired: { ...initial },
  markFired: (id, ts) =>
    set((s) => ({ fired: { ...s.fired, [id]: ts ?? new Date().toISOString() } })),
  hydrate: (snapshot) =>
    set((s) => ({ fired: { ...s.fired, ...snapshot } })),
  reset: () => set({ fired: { ...initial } }),
}));
